module.exports = __webpack_public_path__ + "media/application_advertisement/google_play_store_budge-0151a7ee.svg";